(function () {
  var PLACEHOLDER = '#estimated_date#';
  var DEFAULT_CUTOFF = '12:00';

  function parseCutoffTime(str) {
    if (!str || typeof str !== 'string') return null;
    var trimmed = str.trim();
    var m = /^(\d{1,2})\s*:\s*(\d{2})$/.exec(trimmed);
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (Number.isNaN(h) || Number.isNaN(min) || h < 0 || h > 23 || min < 0 || min > 59) {
      return null;
    }
    return { h: h, m: min };
  }

  /** true si l’heure locale actuelle est >= l’heure limite du jour (fuseau du navigateur). */
  function isAtOrPastCutoffToday(cutoffStr) {
    var parts = parseCutoffTime(cutoffStr || DEFAULT_CUTOFF);
    if (!parts) return false;
    var now = new Date();
    var cutoff = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      parts.h,
      parts.m,
      0,
      0
    );
    return now.getTime() >= cutoff.getTime();
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  /** Ajoute `n` jours ouvrés (lun–ven) en avançant jour par jour, week-ends exclus du décompte. */
  function addBusinessDaysFromToday(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var remaining = n;
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) {
        remaining -= 1;
      }
    }
    return d;
  }

  /** Ajoute `n` jours calendaires à partir d’aujourd’hui (minuit logique à midi pour éviter les bugs DST). */
  function addCalendarDaysFromToday(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return d;
  }

  function addDelayDaysFromToday(n, skipWeekends) {
    if (skipWeekends) {
      return addBusinessDaysFromToday(n);
    }
    return addCalendarDaysFromToday(n);
  }

  function formatEstimatedDate(delayDays, cutoffStr, skipWeekends, cutoffEnabled) {
    var effective = delayDays;
    if (cutoffEnabled && isAtOrPastCutoffToday(cutoffStr)) {
      effective += 1;
    }
    var estimatedDate = addDelayDaysFromToday(effective, skipWeekends);

    var lang = document.documentElement.getAttribute('lang') || 'fr';
    return new Intl.DateTimeFormat(lang, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }).format(estimatedDate);
  }

  function initDeliveryEstimates(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('.delivery-estimate')
      : [];

    nodes.forEach(function (el) {
      var raw = el.getAttribute('data-text') || '';
      var delayRaw = el.getAttribute('data-delay');
      var delayDays = parseInt(delayRaw, 10);
      if (Number.isNaN(delayDays) || delayDays < 0) {
        delayDays = 0;
      }

      var cutoffAttr = el.getAttribute('data-cutoff');
      var skipWeekends = el.getAttribute('data-skip-weekends') !== 'false';
      var cutoffEnabled = el.getAttribute('data-cutoff-enabled') !== 'false';
      var formattedDate = formatEstimatedDate(
        delayDays,
        cutoffAttr || DEFAULT_CUTOFF,
        skipWeekends,
        cutoffEnabled
      );
      var html = raw.split(PLACEHOLDER).join(formattedDate);

      var target = el.querySelector('.delivery-estimate__text');
      if (target) {
        target.innerHTML = html;
      } else {
        el.innerHTML = html;
      }
    });
  }

  window.initDeliveryEstimates = initDeliveryEstimates;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDeliveryEstimates(document);
    });
  } else {
    initDeliveryEstimates(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initDeliveryEstimates(event.target);
    }
  });
})();
